/* OXXRING v2 WP6: client-side filter chips for collection tables (cross-section series, ID range, hardness).
   Nothing here changes the URL: no sort_by or filter. links are created (robots.txt disallows those), and the
   server-rendered rows stay the source of truth for SEO. Chips are built from the rows on the page. */
(function () {
  'use strict';
  var GROUPS = [
    { key: 'cs', label: 'Cross section', unit: ' mm', data: 'cs', series: true },
    { key: 'id', label: 'Inside diameter', unit: ' mm', data: 'id', buckets: [[0, 10, 'under 10'], [10, 25, '10–25'], [25, 50, '25–50'], [50, 100, '50–100'], [100, 250, '100–250'], [250, Infinity, '250+']] },
    { key: 'hard', label: 'Hardness', unit: ' ShA', data: 'hard' },
  ];
  // Standard metric cross-section series; AS568 inch series convert to these values.
  var SERIES = [1, 1.5, 1.78, 2, 2.5, 2.62, 3, 3.53, 4, 5, 5.33, 5.5, 6, 6.99, 7, 8, 10, 12];

  function near(v) {
    var best = null, bd = 0.09;
    SERIES.forEach(function (s) { var d = Math.abs(s - v); if (d <= bd) { best = s; } });
    return best;
  }
  function fmt(v) { return (v % 1 === 0 ? v.toFixed(1) : String(v)).replace(/\.0$/, '.0'); }

  function build(root) {
    var body = root.querySelector('.ic-plp__table tbody');
    if (!body) return;
    var rows = [].slice.call(body.querySelectorAll('tr.ic-row'));
    if (rows.length < 4) return;
    var state = { cs: '', id: '', hard: '' };
    var groups = [];
    GROUPS.forEach(function (g) {
      var counts = {}, order = [];
      rows.forEach(function (r) {
        var raw = r.getAttribute('data-' + g.data);
        if (!raw) return;
        var v = parseFloat(raw);
        if (!(v > 0)) return;
        var key;
        if (g.buckets) { key = g.buckets.filter(function (b) { return v >= b[0] && v < b[1]; })[0]; if (!key) return; key = String(key[2]); }
        else if (g.series) { var s = near(v); key = s === null ? 'other' : String(s); }
        else key = String(v);
        if (!counts[key]) { counts[key] = 0; order.push(key); }
        counts[key]++;
      });
      if (order.length < 2 || order.length > 26) return;
      order.sort(function (a, b) {
        if (a === 'other') return 1; if (b === 'other') return -1;
        if (g.buckets) return g.buckets.map(function (x) { return x[2]; }).indexOf(a) - g.buckets.map(function (x) { return x[2]; }).indexOf(b);
        return parseFloat(a) - parseFloat(b);
      });
      groups.push({ def: g, order: order, counts: counts });
    });
    if (!groups.length) return;

    var counts = root.querySelector('.ic-plp__count');
    var baseCount = counts ? counts.innerHTML : '';
    var bar = document.createElement('div');
    bar.className = 'ic-cfilter';
    groups.forEach(function (g, gi) {
      var wrap = document.createElement('div');
      wrap.className = 'ic-cfilter__group';
      var gl = document.createElement('span');
      gl.className = 'ic-cfilter__label';
      gl.textContent = g.def.label;
      wrap.appendChild(gl);
      var list = document.createElement('div');
      list.className = 'ic-cfilter__chips';
      g.order.forEach(function (key) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ic-cfilter__chip';
        b.setAttribute('aria-pressed', 'false');
        b.dataset.key = g.def.key + '|' + key;
        b.innerHTML = '<span>' + (key === 'other' ? 'other' : key + g.def.unit) + '</span><small>' + g.counts[key] + '</small>';
        b.addEventListener('click', function () {
          var on = b.getAttribute('aria-pressed') === 'true';
          list.querySelectorAll('[aria-pressed="true"]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', on ? 'false' : 'true');
          state[g.def.key] = on ? '' : key;
          apply();
        });
        list.appendChild(b);
      });
      wrap.appendChild(list);
      bar.appendChild(wrap);
    });

    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'ic-link ic-cfilter__clear';
    clear.textContent = 'Clear';
    clear.hidden = true;
    clear.addEventListener('click', function () {
      bar.querySelectorAll('[aria-pressed="true"]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      state.cs = state.id = state.hard = '';
      apply();
    });
    bar.appendChild(clear);

    function match(row) {
      var cs = parseFloat(row.getAttribute('data-cs')), id = parseFloat(row.getAttribute('data-id'));
      if (state.cs) {
        var csKey = near(cs) === null ? 'other' : String(near(cs));
        if (csKey !== state.cs) return false;
      }
      if (state.id) {
        var b = GROUPS[1].buckets.filter(function (x) { return String(x[2]) === state.id; })[0];
        if (b && !(id >= b[0] && id < b[1])) return false;
      }
      if (state.hard && String(row.getAttribute('data-hard')) !== state.hard) return false;
      return true;
    }
    function apply() {
      var shown = 0;
      rows.forEach(function (r) { var ok = match(r); r.hidden = !ok; if (ok) shown++; });
      var active = state.cs || state.id || state.hard;
      clear.hidden = !active;
      if (counts) counts.innerHTML = active ? 'Filtered: <b>' + shown + '</b> of ' + rows.length + ' rows on this page' : baseCount;
      if (window.dataLayer) window.dataLayer.push({ event: 'oxx_collection_filter', cs: state.cs, id_range: state.id, hardness: state.hard, shown: shown });
    }

    var table = root.querySelector('.ic-plp__table');
    table.parentNode.insertBefore(bar, table);
  }

  function boot() { document.querySelectorAll('.ic-plp__main').forEach(function (r) { if (!r.dataset.icCf) { r.dataset.icCf = '1'; build(r); } }); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
